import type {CommitJSON} from "@stepwisehq/prosemirror-collab-commit/collab-commit";

import {GetCollabDocResponse} from "../serverConnection/types";
import {getDocumentFromServer} from "../../sync/DocumentApiRequests";
import {WsServerConnection} from "@stores/serverConnection/wsServerConnection";


export interface DocumentMeta {
    version: number;
    latestEditor: string;
    updatedAt: string;
    comments: Object;
    commentVersion: number
}

export interface CollabLocalState {
    confirmedDoc: any;
    version: number;
    unconfirmed: {
        step: any,
        inverted: any,
    }[],
    commit?: CommitJSON
}

export interface LocalDocumentJSON extends DocumentMeta {
    docId: string;
    doc: any;
    collab?: CollabLocalState;
}

export interface LocalDocumentWithCollabJSON extends LocalDocumentJSON {
    collab: CollabLocalState;
}

/**********************   Doc local serialization  *****************************/
const getFullKey = (key: string) => {
    return `lg_d_${key}`;
}

export const removeLocalDoc = (docId: string) => {
    return localStorage.removeItem(getFullKey(docId));
}

export const getLocalDoc = (docId: string) => {
    const rawLocal = localStorage.getItem(getFullKey(docId));
    return rawLocal ? JSON.parse(rawLocal) : null;
}

export const saveLocalDoc = (docId: string, savedState: LocalDocumentJSON) => {
    localStorage.setItem(getFullKey(docId), JSON.stringify(savedState));
}

export const partialDocUpdate = (docId: string, updateParts: Partial<LocalDocumentJSON>) => {
    const currentLocalVersion = getLocalDoc(docId);
    saveLocalDoc(docId, {
        ...currentLocalVersion,
        ...updateParts,
    });
}
/***********************    End Doc local serialization    ****************************/

export const getDocumentLocalFirst = async (wsServerConnection: WsServerConnection, docId: string, abortController?: AbortController): Promise<GetCollabDocResponse | LocalDocumentJSON> => {
    const localVersion = getLocalDoc(docId);
    if (localVersion) {
        return localVersion;
    } else {
        return await getDocumentAndUpdateLocalState(wsServerConnection, docId, abortController);
    }
}

export const getDocumentAndUpdateLocalState = async (wsServerConnection: WsServerConnection, docId: string, abortController?: AbortController) => {
    const document = await getDocumentFromServer(wsServerConnection, docId, abortController);
    const currentLocalVersion = getLocalDoc(docId);
    if (!currentLocalVersion || !currentLocalVersion?.collab?.unconfirmed?.length) {
        saveLocalDoc(docId, {
            ...document,
        });
    }
    return document;
}

export const hasLocalState = (docInfo: GetCollabDocResponse | LocalDocumentJSON | LocalDocumentWithCollabJSON): docInfo is LocalDocumentWithCollabJSON => {
    return 'collab' in docInfo;
}

